export default __webpack_public_path__ + "static/media/khaled.a5a8a3cf.jpg";